"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@services/modals/section-widget-limit-modal");
var edit_ui_manager_1 = require("@services/report-state/edit-ui-manager");
var unique_string_1 = require("@services/utils/unique-string");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
// @q-red-hover in q-strap
var UPDATES_DISABLED_NOTIF_COLOR = '#BB342E';
var SERVICE_NAME = 'pr.widgetOperationsService';
var NUM_OPERATIONS_TO_LOG = 50; // just to prevent spamming sumo logs if the user does something crazy
var WIDGET_COUNT_WARNING_THRESHOLD = 250;
var OPERATION;
(function (OPERATION) {
    OPERATION["ADD"] = "add";
    OPERATION["DELETE"] = "delete";
    OPERATION["COPY"] = "copy";
    OPERATION["TRANSFORM"] = "transform";
})(OPERATION || (OPERATION = {}));
(function (module) {
    module.factory(SERVICE_NAME, [
        '$q',
        'rsWidgets',
        'pr.PR_WIDGETS',
        'prActiveReport',
        'prFlowingPages',
        'pr.widgetUtils',
        'pr.pageSyncManager',
        'prSectionManager',
        'pr.reportStatus',
        'prEventService',
        'pr.sourceManagement',
        'prMetricsService',
        'pr.widgetManager',
        'pr.statusBarCssManager',
        'pr.loggerService',
        'pr.sectionWidgetLimitModal',
        'pr.widgetCountWarningBannerService',
        'prWidgetInit',
        function ($q, rsWidgets, WIDGETS, report, flowingPages, widgetUtils, pageSyncManager, sectionManager, reportStatus, eventService, sourceManagement, metricsService, widgetManager, statusBarCssManager, loggerService, sectionWidgetLimitModal, widgetCountWarningBannerService, widgetInitService) {
            var loggerManager = loggerService.getLoggerManager(SERVICE_NAME);
            var operationsLog = [];
            return {
                addWidget: wrap(OPERATION.ADD, addWidget),
                copyWidgets: wrap(OPERATION.COPY, copyWidgets),
                deleteWidgets: wrap(OPERATION.DELETE, deleteWidgets),
                finishTransform: wrap(OPERATION.TRANSFORM, finishTransform)
            };
            /************************************
             *          PUBLIC METHODS          *
             ************************************/
            function deleteWidgets(widgetIds) {
                assertTruthyArgs(OPERATION.DELETE, { widgetIds: widgetIds });
                if (!lodash_1.default.isArray(widgetIds)) {
                    widgetIds = [widgetIds];
                }
                var widgets = [];
                var widgetToPageMap = {};
                lodash_1.default.forEach(widgetIds, function (widgetId) {
                    var widget = flowingPages.getWidget(widgetId);
                    widgets.push(widget);
                    var page = report.getWidgetPage(widget);
                    // @ts-ignore
                    widgetToPageMap[widget._id] = page._id;
                });
                var isPageBreakDeletion = (widgets.length === 1) && widgets[0]._type === WIDGETS.PAGE_BREAK;
                if (isPageBreakDeletion) {
                    validateDeletePageBreak(widgets[0]);
                }
                return handleRequest(OPERATION.DELETE, {
                    description: "delete widget(s): " + widgetIds,
                    isSectionUpdate: isPageBreakDeletion,
                    executeRequest: function () {
                        var dbUpdatePromises = widgets.map(report.removeWidget);
                        var uiUpdatePromise = flowingPages.removeWidgets(widgets);
                        eventService.trigger('widgetDeleted');
                        return $q.all(dbUpdatePromises.concat(uiUpdatePromise));
                    },
                    onSuccess: function () {
                        lodash_1.default.forEach(widgets, function (widget) {
                            metricsService.visualizationRemove(widget);
                            if (isPageBreakDeletion) {
                                // page breaks don't have any sources or ripsaw scope
                                return;
                            }
                            sourceManagement.removeWidget(widget._id);
                            var pageId = widgetToPageMap[widget._id];
                            // tell ripsaw to delete the widget scope from the cache
                            rsWidgets.unload(widget._id, pageId);
                        });
                        return removeLeadingPageBreaks();
                    },
                    onError: function () {
                        /**
                         * the widgets were not removed
                         * but flowingPages may have removed them from the page
                         * call reflow so that they show up properly in the ui
                         */
                        return flowingPages.reflow(widgets);
                    }
                });
            }
            function showWidgetCountWarningBannerIfNeeded(amountOfWidgetsToAdd) {
                var oldWidgetsCount = widgetUtils.getWidgetsCount();
                var newWidgetsCount = oldWidgetsCount + amountOfWidgetsToAdd;
                /**
                 * If the old amount of widgets and new amount of widgest are equal to each other when
                 * rounded down by 10, we should not display the banner.
                 *
                 * For example: If oldWidgetsCount is 241, dividing by 10 would make it 24.1 which
                 * would round down to 24. If newWidgetsCount is 248, diving by 10 would make it 24.8
                 * which would round down to 24 and the display banner would not show.
                 *
                 * If the new widgetsCount hits the next bracket of numbers (the 250s in this case)
                 * while the old widget count stays in the lower bracket (240s) we should display the banner.
                 */
                var isWidgetCountThresholdPassed = newWidgetsCount >= WIDGET_COUNT_WARNING_THRESHOLD;
                if (Math.floor(oldWidgetsCount / 10) !== Math.floor((newWidgetsCount / 10)) && isWidgetCountThresholdPassed) {
                    widgetCountWarningBannerService.show();
                }
            }
            function addWidget(widgetType, widgetLayout, pivotWidget, optOptions) {
                if (optOptions === void 0) { optOptions = {}; }
                assertTruthyArgs(OPERATION.ADD, { widgetType: widgetType, widgetLayout: widgetLayout });
                validateAddWidget(widgetType, pivotWidget);
                showWidgetCountWarningBannerIfNeeded(1);
                widgetLayout = getValidWidgetLayout(widgetLayout);
                return handleRequest(OPERATION.ADD, {
                    description: "add widget: " + widgetType,
                    isSectionUpdate: widgetType === WIDGETS.PAGE_BREAK,
                    executeRequest: function () {
                        var pageId = report.getPageIdOfWidget(pivotWidget);
                        return report.addWidget(pageId, widgetType, widgetLayout);
                    },
                    onSuccess: function (newWidget) {
                        // register with service that tracks widget states
                        widgetManager.registerWidget(newWidget._id, newWidget._type);
                        // update the ui
                        return flowingPages.addWidget(newWidget, pivotWidget, optOptions.before);
                    },
                    onError: lodash_1.default.noop
                });
            }
            function copyWidgets(widgetIds, pivotWidget) {
                assertTruthyArgs(OPERATION.COPY, { widgetIds: widgetIds, pivotWidget: pivotWidget });
                validateCopyWidget(widgetIds, pivotWidget);
                /**
                 * Insert widgets in reverse order because we insert each widget after the pivot widget.
                 * We also need to create a deep clone because reverse() mutates the original array and modifies
                 * the order of the selected widgets in body.js
                 */
                widgetIds = lodash_1.default.cloneDeep(widgetIds).reverse();
                showWidgetCountWarningBannerIfNeeded(widgetIds.length);
                return handleRequest(OPERATION.COPY, {
                    description: "copy widget(s): " + widgetIds,
                    isSectionUpdate: false,
                    executeRequest: function () {
                        return $q.all(widgetIds.map(function (widgetId) {
                            var widgetToCopy = flowingPages.getWidget(widgetId);
                            return report.copyWidget(widgetToCopy, pivotWidget);
                        }));
                    },
                    onSuccess: function (newWidgets) {
                        return $q.all(newWidgets.map(function (newWidget) {
                            // update registry of newly added widgets
                            widgetInitService.addNewWidget(newWidget._id);
                            // register with service that tracks widget states
                            widgetManager.registerWidget(newWidget._id, newWidget._type);
                            // update the ui
                            return flowingPages.addWidget(newWidget, pivotWidget);
                        }));
                    },
                    onError: lodash_1.default.noop
                });
            }
            function finishTransform(widgets, allWidgets) {
                assertTruthyArgs(OPERATION.TRANSFORM, { widgets: widgets });
                var widgetIds = lodash_1.default.map(widgets, '_id');
                return handleRequest(OPERATION.TRANSFORM, {
                    description: "transform widget(s): " + widgetIds,
                    isSectionUpdate: true,
                    executeRequest: function () {
                        // @ts-ignore
                        return sectionManager.finishTransform(widgets, allWidgets);
                    },
                    onSuccess: function () {
                        return removeLeadingPageBreaks();
                    },
                    onError: lodash_1.default.noop
                });
            }
            /************************************
             *          HELPER METHODS          *
             ************************************/
            /**
             * Every operation has two phases
             * (1) make request to containers-api to update database
             * (2) perform non-blocking post-processing after the database is updated (e.g. update widgetManager)
             * Callers of this method should receive a promise that resolves after (1).
             * because (2) is for anything that might be intensive that shouldn't stall the ui
             *
             * Notes on section changes:
             * 	Creating/deleting/updating sections causes several interdependent network requests (see section-manager.js).
             * 	If the sequence of requests is interrupted, then widgets can lose state or disappear.
             * 	So disable all other operations when sections are in the process of being added/deleted.
             */
            function handleRequest(operation, options) {
                var id = unique_string_1.getUniqueString();
                reportStatus.savePending(id);
                operationsLog.push({
                    description: options.description,
                    timestamp: new Date().toISOString()
                });
                var originalPagesInDatabase;
                if (options.isSectionUpdate) {
                    // interruptions while adding/deleting/updating section can be very bad!
                    edit_ui_manager_1.editUIManager.startSectionUpdate();
                    /**
                     * keep track of the container state before the update
                     * in case we need to revert any breaking changes.
                     * This is only needed for failures with section updates;
                     * other failures are automatically handled by prActiveReport
                     */
                    originalPagesInDatabase = lodash_1.default.cloneDeep(report.getPages());
                }
                // wrap response in $q.resolve() so we can safely call .then without error
                var responsePromise = $q.resolve().then(options.executeRequest);
                // perform operation-specific post-processing
                responsePromise.then(options.onSuccess).then(function () {
                    validateChange();
                    reportStatus.saveSucceeded(id);
                }).catch(function (error) {
                    reportStatus.saveFailed(id);
                    logError(operation, error, options);
                    // perform any operation-specific error handling
                    options.onError(error);
                    if (originalPagesInDatabase) {
                        return restoreReport(originalPagesInDatabase);
                    }
                }).finally(function () {
                    if (options.isSectionUpdate) {
                        edit_ui_manager_1.editUIManager.completeSectionUpdate();
                    }
                });
                // return without waiting for .then so that the ui can be responsive
                return responsePromise;
            }
            function restoreReport(originalPagesInDatabase) {
                return pageSyncManager.setPages(originalPagesInDatabase);
            }
            /**
             * Validate changes succeeded by comparing the ui state with the db state.
             * If there are any widgets in the ui that isn't in the db (or vice-versa),
             * then the ui is in an invalid state.
             */
            function validateChange() {
                if (!pageSyncManager.arePagesInSync()) {
                    throw new Error('The ui state does not match the db state');
                }
            }
            function logError(operation, error, options) {
                var message = SERVICE_NAME + "." + operation + " request failed";
                console.error(message, error);
                loggerManager.error({
                    message: message,
                    isSectionUpdate: options.isSectionUpdate,
                    description: options.description,
                    error: error,
                    operationsLog: lodash_1.default.takeRight(operationsLog, NUM_OPERATIONS_TO_LOG),
                    uiPages: getPagesWithoutState(flowingPages.getPages()),
                    dbPages: getPagesWithoutState(report.getPages())
                });
            }
            function getPagesWithoutState(pages) {
                return pages.map(function (page) {
                    return lodash_1.default.mapValues(page, function (value, key) {
                        if (key !== 'widgets') {
                            return value;
                        }
                        var widgets = value || [];
                        return widgets.map(function (widget) {
                            return lodash_1.default.omit(widget, ['state', 'layout']);
                        });
                    });
                });
            }
            function getValidWidgetLayout(widgetLayout) {
                return __assign(__assign({}, widgetLayout), { rowSpan: getValidSpan(widgetLayout.rowSpan), colSpan: getValidSpan(widgetLayout.colSpan) });
                /**
                 * Risaw will only save the layout if the
                 * rowSpan and colSpan are both positive integers
                 */
                function getValidSpan(span) {
                    if (!lodash_1.default.isNumber(span)) {
                        return 1;
                    }
                    return Math.max(Math.ceil(span), 1);
                }
            }
            function removeLeadingPageBreaks() {
                return $q.resolve().then(function () {
                    var leadingPageBreakIds = getLeadingPageBreakIds();
                    if (leadingPageBreakIds.length) {
                        return deleteWidgets(leadingPageBreakIds);
                    }
                });
            }
            function getLeadingPageBreakIds() {
                var leadingPageBreakIds = [];
                lodash_1.default.forEach(flowingPages.getWidgets(), function (widget) {
                    if (widget._type !== WIDGETS.PAGE_BREAK) {
                        return false;
                    }
                    leadingPageBreakIds.push(widget._id);
                });
                return leadingPageBreakIds;
            }
            function assertTruthyArgs(operation, argMap) {
                lodash_1.default.forEach(argMap, function (val, key) {
                    if (!val) {
                        throw new Error(SERVICE_NAME + "." + operation + ": " + key + " must be truthy. Received " + val + ".");
                    }
                });
            }
            function validateAddWidget(widgetType, pivotWidget) {
                validateWidgetsCanBeAddedToReport(1);
                var pageId = report.getPageIdOfWidget(pivotWidget);
                validateWidgetsCanBeAddedToSection(pageId, [widgetType]);
            }
            function validateCopyWidget(widgetIds, pivotWidget) {
                validateWidgetsCanBeAddedToReport(widgetIds.length);
                var pageId = report.getPageIdOfWidget(pivotWidget);
                var widgetsToCopy = widgetIds.map(flowingPages.getWidget);
                // @ts-ignore
                var widgetTypes = lodash_1.default.map(widgetsToCopy, '_type');
                validateWidgetsCanBeAddedToSection(pageId, widgetTypes);
            }
            function validateDeletePageBreak(pageBreak) {
                var widgets = widgetUtils.getWidgets();
                var pageBreakIndex = lodash_1.default.findIndex(widgets, { _id: pageBreak._id });
                var widgetBeforeBreak = widgets[pageBreakIndex - 1];
                if (!widgetBeforeBreak) {
                    return;
                }
                var pageIdBeforeBreak = report.getPageIdOfWidget(widgetBeforeBreak);
                var pageAfterWidget = report.getWidgetPage(pageBreak) || {};
                // @ts-ignore
                var widgetTypesToMove = lodash_1.default.map(pageAfterWidget.widgets, '_type');
                if (!widgetUtils.canWidgetsBeAddedToSection(pageIdBeforeBreak, widgetTypesToMove)) {
                    sectionWidgetLimitModal.onDeletePageBreak();
                    throw new Error('Cannot delete page break due to section widget limit');
                }
            }
            function validateWidgetsCanBeAddedToReport(numWidgets) {
                if (!widgetUtils.canWidgetsBeAddedToReport(numWidgets)) {
                    throw new Error('Cannot add widget due to report widget limit');
                }
            }
            function validateWidgetsCanBeAddedToSection(pageId, widgetTypes) {
                if (!widgetUtils.canWidgetsBeAddedToSection(pageId, widgetTypes)) {
                    sectionWidgetLimitModal.onAddWidget();
                    throw new Error('Cannot add widget due to section widget limit');
                }
            }
            /**
             * Returns a wrapped version of the operation method to guarantee:
             * 	(1) the operation always returns a promise
             * 	(2) the operation doesn't run if a section update is pending
             * 	@param {Function} func - main function to perform the operation
             * 	@returns {Function} - modified version of the passed in function
             */
            function wrap(operation, func) {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return $q.resolve().then(function () {
                        if (!edit_ui_manager_1.editUIManager.isSectionUpdatePending()) {
                            return func.apply(void 0, args);
                        }
                        console.warn('${SERVICE_NAME}.${operation} blocked because edits are temporarily disabled');
                        // show a subtle warning to notify the user that updates are currently being saved
                        statusBarCssManager.highlight('1s', UPDATES_DISABLED_NOTIF_COLOR);
                    });
                };
            }
        }
    ]);
})(angular_1.module('qualtrics.pr'));
